export default __webpack_public_path__ + "static/media/Snd_TryN.c5967292.mp3";